<div class="loginFormWrapper"
         [class.media-handset]="layoutMatches.isHandsetDefaultLayout">
  <section  class="form-section">
    <div class="progress-bar-spinner" [class.dark-grey-red-theme]="true">
      <mat-progress-bar style="margin: 0px; padding: 0px;" *ngIf="application.isActiveRequest" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-card *ngIf="application.state=='setup_mfa_ga'">
      <h1>2-factor authentication setup</h1><br>
      <p class="radio-group">
        You need to set up 2-factor authentication to proceed. Please follow this one-time procedure to complete the setup.
      </p>
      <p class="radio-group primary-text">
        1) Install any authenticator app from App Store, Google Play or Windows Store, for example Google Authenticator or Microsoft Authenticator.
      </p>
      <p class="radio-group primary-text">
        2) Tap ‘Setup Account’ or ‘+’ in the app on your mobile device.
      </p>
      <p class="radio-group primary-text">
        3) Scan the barcode or enter the below key manually.
      </p>
      <p class="radio-group primary-text">
        4) You will see a 6-digit code in the app. Press ‘Proceed’ and enter the 6-digit code from the app.
      </p>
      <p class="radio-group">
        Every time you login, open the authenticator app on your mobile and enter the 6-digit code.
      </p>
      <div class="form-group">
        <mat-grid-list cols="2" rowHeight="4:4">
          <mat-grid-tile>
            <section style="width:100%; text-align: right;">
              QR Code:
            </section>
          </mat-grid-tile>
          <mat-grid-tile>
            <section>
              <img class="qr-img" src="data:image/jpeg;base64,{{application.ga_qr_code}}" alt="QR Code">
            </section>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="4:1">
          <mat-grid-tile>
            <section style="width:100%; text-align: right;">
              Manual Key Entry:
            </section>
          </mat-grid-tile>
          <mat-grid-tile>
            <span class="ga-secret">{{application.ga_secret}}</span>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
      <div class="form-group">
        <mat-grid-list cols="2" rowHeight="4:1">
          <mat-grid-tile>
            <section style="width:100%; text-align: left;">
              <button mat-button color="accent" (click)="cancel2faCode()" style="text-align: left; padding-left: 0px;">
                Cancel
              </button>
            </section>
          </mat-grid-tile>
          <mat-grid-tile>
            <section style="width:100%; text-align: right;">
              <button mat-raised-button color="accent" (click)="confirmGaMfa()">Proceed</button>
            </section>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-card>
    <mat-card *ngIf="application.state=='setup_mfa_sms'">
      <form [formGroup]="setupSmsForm">
        <h1>2-factor authentication setup</h1><br>
        <p>
          You need to set up 2-factor authentication to proceed. Please follow this one-time procedure to complete the setup.
        </p>

        <div class="errorContainer" *ngIf="faCodeError">
          <mat-icon class="loginErrorIcon" color="warn">error</mat-icon> {{faCodeError}}
        </div>

        <p class="primary-text">
          <br/>
          1) Enter your mobile phone number in full international format and click ‘Proceed’.
        </p>
        <div class="form-group">
          <mat-form-field style="width: 100%" color="accent">
            <input matInput cdkFocusInitial placeholder="Phone number"
                   formControlName="phone_number" autofocus value=""
                   mat-tooltip="">
          </mat-form-field>
        </div>
        <p class="primary-text">
          2) You will receive an SMS with a 6-digit code.
        </p>
        <p>
          <br/>
          You will receive an SMS message with the 6-digit code every time you login.
        </p>
        <div class="form-group">
          <mat-grid-list cols="2" rowHeight="4:1">
            <mat-grid-tile>
              <section style="width:100%; text-align: left;">
                <button mat-button color="accent" (click)="cancel2faCode()" style="text-align: left; padding-left: 0px;">
                  Cancel
                </button>
              </section>
            </mat-grid-tile>
            <mat-grid-tile>
              <section style="width:100%; text-align: right;">
                <button mat-raised-button color="accent" (click)="setupSmsCode()">Proceed</button>
              </section>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </form>
    </mat-card>
    <mat-card *ngIf="application.state=='enter_mfa_ga'">
      <form [formGroup]="enter2facodeForm">
        <h1>Please enter your 6-digit code to proceed.</h1><br/>
        <div class="errorContainer" *ngIf="faCodeError" style="margin-bottom: 15px;">
          <mat-icon class="loginErrorIcon" color="warn">error</mat-icon> {{faCodeError}}
        </div>
        <div class="form-group">
          <mat-form-field style="width: 100%" color="accent">
            <input matInput cdkFocusInitial placeholder="Please enter the 2FA code you received via SMS"
                   formControlName="code_2fa" autofocus value=""
                   mat-tooltip="">
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-grid-list cols="2" rowHeight="4:1">
            <mat-grid-tile>
              <section style="width:100%; text-align: left;">
                <button mat-button color="accent" (click)="cancel2faCode()" style="text-align: left; padding-left: 0px;">
                  Cancel
                </button>
              </section>
            </mat-grid-tile>
            <mat-grid-tile>
              <section style="width:100%; text-align: right;">
                <button mat-raised-button color="accent" (click)="send2faCode('GA')">VERIFY</button>
              </section>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </form>
    </mat-card>
    <mat-card *ngIf="application.state=='enter_mfa_sms'">
      <form [formGroup]="enter2facodeForm">
        <h1>Please enter your 6-digit code to proceed</h1><br/>
        <div class="errorContainer" *ngIf="faCodeError">
          <mat-icon class="loginErrorIcon" color="warn">error</mat-icon> {{faCodeError}}
        </div>
        <div class="form-group">
          <mat-form-field style="width: 100%" color="accent">
            <input matInput cdkFocusInitial placeholder="Please enter the 2FA code you received via SMS"
                   formControlName="code_2fa" autofocus value=""
                   mat-tooltip="">
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-grid-list cols="2" rowHeight="4:1">
            <mat-grid-tile>
              <section style="width:100%; text-align: left;">
                <button mat-button color="accent" (click)="cancel2faCode('SMS')" style="text-align: left; padding-left: 0px;">
                  Cancel
                </button>
              </section>
            </mat-grid-tile>
            <mat-grid-tile>
              <section style="width:100%; text-align: right;">
                <button mat-raised-button color="accent" (click)="send2faCode('SMS')">VERIFY</button>
              </section>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </form>
    </mat-card>
  </section>
</div>